module.exports = __webpack_public_path__ + "static/media/header_dashboard_logo.dfc0b5e2.svg";